const styles = theme => ({
  galleryModalBody: {
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      top: '30%',
      width: '100%',
    },
  },
  caroselWrapper: {
    marginBottom: '20px',
  },
  corouselImgContainer: {
    height: '400px',
    width: '100%',
    position: 'relative',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
    [theme.breakpoints.down('md')]: {
      height: '300px',
    },
    [theme.breakpoints.down('xs')]: {
      height: '200px',
    },
  },
  fullScreenIcon: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    background: 'rgba(0,0,0,0.5)',
    borderRadius: 0,
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
  icon: {
    color: theme.palette.primary.white,
  },
  fullScreenDialog: {
    height: '100vh',
  },
  fullScreenPaper: {
    background: theme.palette.primary.adgmBlack,
  },
  appBar: {
    position: 'relative',
    background: theme.palette.primary.adgmBlack,
    maxHeight: '10vh',
  },
  title: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  dialogImageContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  dialogImage: {
    width: '100%',
    maxHeight: '90vh',
    background: theme.palette.primary.white,
  },
});

export default styles;
